import { computed, watch } from '@nuxtjs/composition-api';

export const useProductListingBreadcrumbs = ({
  store,
  i18n,
  title,
  formatUrl,
  gtmDispatch
}: {
  store: any;
  i18n: any;
  formatUrl: (url: string) => string;
  title: string;
  gtmDispatch: (categoryPath: string) => void;
}) => {
  const rawBreadcrumbs = computed(() => store.getters['page/getBreadcrumb']);

  const formattedBreadcrumbs = computed(() => {
    let data;

    data = rawBreadcrumbs.value;
    if (!data || data.length === 0) {
      data = [
        {
          parenttaggroup: title
        }
      ];
    }

    return [
      {
        text: i18n.t('breadcrumbs_home'),
        link: formatUrl('/'),
        testId: i18n.t('breadcrumbs_home')
      },
      {
        text: data[0].parenttaggroup,
        link: formatUrl(data[0].parenttaggroup_url),
        testId: data[0].category_level_1_nl
      },
      {
        text: data[0].producttaggroup,
        link: formatUrl(data[0].producttaggroup_url),
        testId: data[0].category_level_2_nl
      },
      {
        text: data[0].producttag_name,
        link: '#',
        testId: data[0].category_title_nl
      }
    ];
  });

  // GTM side effect
  watch(
    formattedBreadcrumbs,
    () => {
      if (formattedBreadcrumbs.value.length >= 4) {
        const path = [
          formattedBreadcrumbs.value[1].text,
          formattedBreadcrumbs.value[2].text,
          formattedBreadcrumbs.value[3].text
        ].join('/');

        gtmDispatch(path);
      }
    },
    { immediate: true }
  );

  return {
    formattedBreadcrumbs
  };
};
